var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShots = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 46.5,
  height: 46.5,
  x: 0.75,
  y: 0.75,
  stroke: "#183690",
  strokeWidth: 1.5,
  rx: 23.25
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#183690",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.3,
  d: "M16.088 20.752c2.234 0 4.045-1.903 4.045-4.25s-1.811-4.251-4.045-4.251-4.044 1.903-4.044 4.25 1.81 4.251 4.044 4.251M16.088 11.4V8M20.941 16.502h3.236M19.324 13.1l2.426-2.55M12.853 13.1l-2.426-2.55M11.235 16.502H8M32.72 23.635c1.787 0 3.236-1.523 3.236-3.4 0-1.879-1.449-3.401-3.236-3.401s-3.235 1.522-3.235 3.4 1.448 3.4 3.235 3.4M32.72 15.983v-3.4M36.765 20.234H40M28.676 20.234h-3.235M23.318 37.875c1.563 0 2.83-1.333 2.83-2.976s-1.267-2.975-2.83-2.975-2.831 1.332-2.831 2.975 1.267 2.976 2.83 2.976M23.318 31.87v-3.4M25.744 37.45 28.171 40M20.89 37.45 18.465 40"
})));
export default SvgShots;